import * as React from 'react';
import styled from 'styled-components';
import { usePopper } from 'react-popper';

// https://inclusive-components.design/tooltips-toggletips/

type TooltipWrapperProps = {
    backgroundColor?: string,
    children:React.ReactNode,
    tooltip?:React.ReactNode,
    sizePx?:number,
    cursor?:'pointer'|'default'|'crosshair'
    wrapper?:'div'|'span'
}
export function TooltipWrapper(props:TooltipWrapperProps):JSX.Element
{
    const [referenceElement, setReferenceElement] = React.useState(null);
    const [popperElement, setPopperElement] = React.useState(null);
    const { styles, attributes } = usePopper(referenceElement, popperElement, {
        placement: "bottom-end", 
    });

    function showTooltip()
    {
        popperElement.setAttribute('data-show', true);
    }

    function hideTooletip()
    {
        popperElement.removeAttribute('data-show');
    }

    const wrapperProps = {
        onMouseOver:()=>{
            if(props.tooltip)
                showTooltip()
        },
        onMouseOut:()=>{
            if(props.tooltip)
                hideTooletip();
        },
        ref:setReferenceElement
    }

    const wrapperChildren = 
        <>
            {props.children}
            {props.tooltip &&
                <TooltipContainer ref={setPopperElement} style={{...styles.popper}} {...attributes.popper}>
                    <StyledTooltipDiv maxWidth={props.sizePx ? `${props.sizePx}px` : undefined}>
                        {props.tooltip}
                    </StyledTooltipDiv>
                </TooltipContainer>
            }
        </>;

    return (
        <>
            {props.wrapper === 'span' 
                ?   <span {...wrapperProps}>
                        {wrapperChildren}
                    </span>

                :   <div {...wrapperProps}>
                        {wrapperChildren}
                    </div>
            }
        </>
    );
}

const TooltipContainer = styled.div`
    visibility: hidden;
    z-index: 1000;
    &[data-show="true"] {
        visibility: visible;
    }
`;

const Gray_dark = "rgba(61,61,61,1)";

export const StyledTooltipDiv = styled.div<{maxWidth?:string}>`
    background-color: ${Gray_dark};
    border-width: 1px;
    border-radius: 4px;
    border-style: solid;
    border-color: #555 transparent transparent transparent;
    font-family: "Noto Sans", sans-serif;
    font-size: 14px;
    color:#fff;
    font-weight: 400;
    padding: 10px;
    position: relative;
    transition: opacity 0.3s;
`;